import {needAuth} from "../instance/Instance";

async function getLicenseCheck() {
    return await needAuth.get(`/licenseCheck`);
}

export {getLicenseCheck}